import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mode: "light",
  userId: null,
  sidebarOpen: true,
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
    setSidebarOpen: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
  },
});

export const { setMode, setUserId, setSidebarOpen } = globalSlice.actions;
export default globalSlice.reducer;
